document.addEventListener("DOMContentLoaded", function () {
    document.querySelector('.comment-loading').classList.add('is-loading');
    const delete_modal_block = document.querySelector('div.delete_modal_block');
    let comment_id;
    let customer_id;
    let status = 0;

    postDailyCalendarReadHistory()

    document.addEventListener('click', async function (event) {
        let targetElement = event.target;

        if (targetElement.classList.contains('daily_pad_calendar_comment_remove_span')) {
            targetElement = targetElement.parentElement;
        }

        switch (targetElement.className) {
            case 'daily_pad_calendar_comment_remove':
                delete_modal_block.style.display = 'flex';
                comment_id = targetElement.dataset.commentId;
                customer_id = targetElement.dataset.customerId;
                status = 1;
                break;
            case 'delete_button_no':
                delete_modal_block.style.display = 'none';
                comment_id = null;
                customer_id = null;
                status = 0;
                break;
            case 'delete_button_yes':
                delete_modal_block.style.display = 'none';
                if (!comment_id) break;
                const currentCommentId = comment_id;
                const params = JSON.stringify({
                    "comment_id": currentCommentId,
                    "customer_id": customer_id
                });
                let url = `${window.AppProxyPath}/api/customers/daily/remove`;
                document.querySelector('.cooklist_loading_container').style.display = 'block';
                document.querySelector('.mizkan__top').hidden = true;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: params
                })
                    .then(response => {
                        if (response.ok) {
                            return response.json().then(data => {
                                sessionStorage.setItem('deletedCommentId', currentCommentId);
                                setTimeout(function () {
                                    window.location.reload();
                                }, 3000);
                            });
                        } else if (response.status !== 404) {
                            throw new Error('Server or client error');
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        open_modal_error('#error_modal');
                        document.querySelector('.cooklist_loading_container').style.display = 'none';
                        document.querySelector('.mizkan__top').hidden = false;
                    });
                comment_id = null;
                customer_id = null;
                status = 0;
                break;
        }
    });

    var showMoreButton = document.getElementById("showMoreComments");
    setTimeout(function () {
        loadComments(null, true);
        showMoreButton.disabled = false;
    }, 3000);

    // ボタン「コメントをもっと見る」押下時
    showMoreButton.addEventListener("click", async function () {
        const cursor = showMoreButton.getAttribute('cursor');
        if (cursor) {
            showMoreButton.disabled = true;
            await loadComments(cursor, false);
            showMoreButton.disabled = false;
        }
    });
});

async function postDailyCalendarReadHistory() {
    const pathName = window.location.pathname
    
    // 週間チャレンジ期間外、または未ログイン時は閲覧履歴は登録しない
    if (
        !pathName.startsWith('/pages/daily_pad_calendar')
        || !document.getElementById('modal_weekly-challenge')
        || !document.getElementById('modal_weekly-challenge').dataset.customer_id
    ) return

    const splittedPathName = pathName.split('/')

    let targetDate
    if (splittedPathName.length === 4 && !!splittedPathName[3]) {
        targetDate = splittedPathName[3]
    } else {
        const currentDate = new Date()
        const year = currentDate.getFullYear().toString().padStart(4, '0');
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const day = currentDate.getDate().toString().padStart(2, '0');
        targetDate = `${year}-${month}-${day}`
    }

    await fetch(
        `${window.AppProxyPath}/api/customers/daily/history`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({targetDate}),
        }
    );
}

var week_days = ['日', '月', '火', '水', '木', '金', '土'];
if (document.querySelector('.mizkan__top__currentday__calendar')) {
    document.querySelector('.mizkan__top__currentday__calendar').addEventListener('click', function (e) {
        e.preventDefault();
        toggleChangeMonthButton();
        open_modal('#modal_monthly-calendar');
        let c_year = document.querySelector('.calendar__year').getAttribute('datetime');
        let c_month = this.dataset.month;
        updateCalendarList(c_year, c_month, true);
    });
}

if (document.querySelector('#weekly_challenge_button')) {
    document.querySelector('#weekly_challenge_button').addEventListener('click', async function (e) {
        e.preventDefault();
        document.getElementById('weekly_challenge_entry_contents').hidden = true
        
        open_modal('#modal_weekly-challenge');
        
        const firstTimeElem = document.getElementById('weekly_challenge_entry_contents').getElementsByTagName('time')[0]
        const weeklyChallengeStartDate = firstTimeElem.getAttribute('datetime')
        await updateWeeklyChallengeList(weeklyChallengeStartDate)

        document.getElementById('weekly_challenge_entry_contents').hidden = false
    });
}

function open_modal_ng(id_modal) {
    // モーダルを閉じる
    document.querySelector('#modal_input_error button').addEventListener('click', function () {
        document.querySelector('#modal_input_error').classList.remove('open');
    })

    // モーダル表示
    document.querySelector('#modal_input_error').classList.add('open');
}

function open_modal(id_modal) {

    const modal = document.querySelector(id_modal);
    const body = document.body;

    // モーダルを閉じる
    modal.addEventListener('click', function (event) {
        if (event.target === modal || event.target.classList.contains('modal-close')) {
            modal.classList.remove('active');
            body.style.overflow = 'auto';
        }
    });

    // モーダル表示
    modal.classList.add('active');
    body.style.overflow = 'hidden';
}

function toggleChangeMonthButton() {
    let today = new Date();
    let mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    let yyyy = today.getFullYear();
    let today_month = yyyy + '-' + mm;
    mm = document.querySelector('.calendar__date-info_wrapper .calendar__month-number').textContent.padStart(2, '0');
    let cur_month = document.querySelector('.calendar__date-info_wrapper .calendar__year').getAttribute('datetime') + '-' + mm;

    document.querySelector('.calendar__date-wrapper .calendar__arrow--left').dataset.month = parseInt(mm) - 1;
    document.querySelector('.mizkan__top__currentday__calendar').dataset.month = mm;

    // 12月から1月への遷移の特別処理
    const isDecember = mm === '12';
    const nextYear = document.querySelector('.calendar__year').getAttribute('datetime');
    const isCurrentYearOrLess = parseInt(nextYear) < parseInt(yyyy);

    if (today_month > cur_month || (isDecember && isCurrentYearOrLess)) {
        document.querySelector('.calendar__date-wrapper .calendar__arrow--right').removeAttribute('hidden');
        document.querySelector('.calendar__date-wrapper .calendar__arrow--right').dataset.month = parseInt(mm) + 1;
    } else {
        document.querySelector('.calendar__date-wrapper .calendar__arrow--right').setAttribute('hidden', true);
    }

    if (cur_month === '2024-03') {
        document.querySelector('.calendar__date-wrapper .calendar__arrow--left').style.display = 'none';
        document.querySelector('.calendar__date-wrapper').style.justifyContent = 'flex-end';
    } else {
        document.querySelector('.calendar__date-wrapper .calendar__arrow--left').style.display = '';
        document.querySelector('.calendar__date-wrapper').style.justifyContent = 'space-between';
    }
}

let changeMonthBtn = document.querySelectorAll(".calendar__arrow");

changeMonthBtn.forEach(function (elem) {
    elem.addEventListener("click", function () {
        updateDateWrapper(this);
        toggleChangeMonthButton();
        let c_year = document.querySelector('.calendar__year').getAttribute('datetime');
        let c_month = document.querySelector('.calendar__month-number').textContent;
        updateCalendarList(c_year, c_month, false);
    });
});

function updateDateWrapper(el) {
    var new_year = document.querySelector('.calendar__year').getAttribute('datetime');
    var is_change_year = false;
    if (el.dataset.month < 1) {
        el.dataset.month = 12;
        new_year--;
        is_change_year = true;
    } else if (el.dataset.month > 12) {
        el.dataset.month = 1;
        new_year++;
        is_change_year = true;
    }
    document.querySelector('.calendar__month-number').textContent = el.dataset.month;
    document.querySelector('.calendar__year').textContent = new_year;
    document.querySelector('.calendar__year').setAttribute('datetime', new_year);
    document.querySelector('.calendar__era').textContent = '令和' + (new_year - 2018) + '年';

    if (!is_change_year) {
        if (el.classList.contains('calendar__arrow--left')) {
            el.dataset.month--;
        } else {
            el.dataset.month++;
        }
    }
}

const updateCalendarList = (() => {
    let currentRequest = 0;

    return async function(year, month, isInitialLoad = false) {
        const thisRequest = ++currentRequest;
        
        if (document.querySelector('.calendar__entry:not(.calendar__entry__template)')) {
            document.querySelectorAll('.calendar__entry:not(.calendar__entry__template)').forEach(e => e.remove());
        }

        document.querySelector('#show_more_himekuri_calendar').classList.add('is-loading');

        if (!isInitialLoad && month < 10 && month.toString().length === 1) {
            month = '0' + month;
        }

        try {
            const result = await fetch(`${window.AppProxyPath}/api/customers/daily/calendar?year=` + year + '&month=' + month, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });

            const res = await result.json();
            
            // このリクエストが最新でない場合は処理を中止
            if (thisRequest !== currentRequest) {
                return;
            }

            if (res.done) {
                document.querySelector('#show_more_himekuri_calendar').classList.remove('is-loading');
                if (res.data) {
                    res.data.sort((a, b) => {
                        const getDateValue = (item) => {
                            let dateValue = item.node.fields.find(obj => obj.key === 'date').value;
                            // 日付部分（dd）のみを取得して比較
                            let day;
                            if (dateValue.split('-').length === 2) {
                                // mm-dd形式の場合
                                day = parseInt(dateValue.split('-')[1]);
                            } else {
                                // yyyy-mm-dd形式の場合
                                day = parseInt(dateValue.split('-')[2]);
                            }
                            return day;
                        };

                        let dayA = getDateValue(a);
                        let dayB = getDateValue(b);
                        return dayA - dayB;  // 昇順でソート（日付の小さい順）
                    });

                    let today = new Date();
                    today.setHours(0, 0, 0, 0);

                    let allText = '';
                    res.data.forEach(function (calendar) {
                        let new_entry = document.querySelector('.calendar__entry__template').cloneNode(true);
                        new_entry.classList.remove('calendar__entry__template');
                        new_entry.removeAttribute('data-customer_id');
                        new_entry.removeAttribute('data-icon_gray');

                        let date_field = calendar.node.fields.filter(obj => {
                            return obj.key === 'date';
                        });
                        let str_day;
                        if (date_field[0].value.split('-').length === 2) {
                            str_day = year + '-' + date_field[0].value;
                        } else {
                            // yy-mm-dd形式の場合、yyyyに変換
                            let dateParts = date_field[0].value.split('-');
                            let yy = dateParts[0];
                            let fullYear = yy.length === 2 ? '20' + yy : yy;  // 2桁年の場合は20xx年と仮定
                            str_day = fullYear + '-' + dateParts[1] + '-' + dateParts[2];
                        }

                        if (str_day) {
                            let dateParts = str_day.split('-');
                            let month = dateParts[1];
                            let day = dateParts[2];
                            let c_date = new Date(year, parseInt(month) - 1, parseInt(day));
                            c_date.setHours(0, 0, 0, 0);
                            new_entry.querySelector('dt time').textContent = c_date.getDate() + '日(' + week_days[c_date.getDay()] + ')';
                            new_entry.querySelector('dt time').setAttribute('datetime', str_day);
                            allText += ' ' + c_date.getDate() + '日(' + week_days[c_date.getDay()] + ')';
                        }

                        let title_field = calendar.node.fields.filter(obj => {
                            return obj.key === 'title';
                        });
                        if (title_field[0].value) {
                            let titleText = title_field[0].value;
                            let eventDate = new Date(year, parseInt(str_day.split('-')[1]) - 1, parseInt(str_day.split('-')[2]));
                            eventDate.setHours(0, 0, 0, 0);
                            if (eventDate > today) {
                                titleText = `???????の日`;
                                new_entry.querySelector('.calendar__entry-link').innerHTML = '';
                            }
                            new_entry.querySelector('.calendar__text').textContent = titleText;
                            allText += ' ' + titleText;
                        }

                        if (document.querySelector('.calendar__entry__template').dataset.customer_id) {
                            new_entry.querySelector('.calendar__icon img').src = document.querySelector('.calendar__entry__template').dataset.icon_gray;
                            let headset_field = calendar.node.fields.filter(obj => {
                                return obj.key === 'suchan_headset';
                            });
                            if (headset_field[0].value) {
                                new_entry.querySelector('.calendar__icon img').dataset.src = headset_field[0].reference.image.url;
                            }
                        } else {
                            let today = new Date();
                            let dd = String(today.getDate()).padStart(2, '0');
                            let mm = String(today.getMonth() + 1).padStart(2, '0');
                            let yyyy = today.getFullYear();
                            today = yyyy + '-' + mm + '-' + dd;
                            if (today == str_day) {
                                let headset_field = calendar.node.fields.filter(obj => {
                                    return obj.key === 'suchan_headset';
                                });
                                if (headset_field[0].value) {
                                    new_entry.querySelector('.calendar__icon img').src = headset_field[0].reference.image.url;
                                }
                            } else {
                                new_entry.querySelector('.calendar__icon img').src = document.querySelector('.calendar__entry__template').dataset.icon_gray;
                            }
                        }

                        let eventDate = new Date(year, parseInt(str_day.split('-')[1]) - 1, parseInt(str_day.split('-')[2]));
                        eventDate.setHours(0, 0, 0, 0);
                        if (eventDate <= today) {
                            new_entry.querySelector('.calendar__entry-link').href = '/pages/daily_pad_calendar/' + str_day;
                        } else {
                            new_entry.querySelector('.calendar__entry-link').remove();
                        }
                        document.querySelector('.calendar__list').append(new_entry);
                    });
                    fontJun501(allText);

                    markLoginDates(year, month);
                }
            }
        } catch (error) {
            // このリクエストが最新の場合のみエラー処理を実行
            if (thisRequest === currentRequest) {
                console.error('Error:', error);
                document.querySelector('#show_more_himekuri_calendar').classList.remove('is-loading');
            }
        }
    };
})();

const updateWeeklyChallengeList = (async (startDate) => {
    document.querySelector('#weekly_challenge_loading').classList.add('is-loading');

    try {
        const result = await fetch(`${window.AppProxyPath}/api/customers/daily/check-read-history/${startDate}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });

        const res = await result.json();
        if (res.readedDates?.length) {
            let inCompleteIconId = ''
            let completeIconId = ''
            res.readedDates.forEach((readedDate) => {
                inCompleteIconId = `weekly_challenge_icon_${readedDate}`
                completeIconId = `weekly_challenge_complete_icon_${readedDate}`
                document.getElementById(inCompleteIconId).hidden = true
                document.getElementById(completeIconId).hidden = false
            })
        }
    } catch (error) {
        console.error('Error:', error);
    }

    document.querySelector('#weekly_challenge_loading').classList.remove('is-loading');
})


async function markLoginDates(year, month) {
    // API通信
    let url = `${window.AppProxyPath}/api/customers/daily/login-history`;
    let params = `{ "year": "${year}", "month": "${month}" }`;
    const response = await fetch(url, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: params
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        return json;
    })

    let loginDates = response.data;
    if (loginDates) {
        for (let i = 0; i < loginDates.length; i++) {
            const originalDate = new Date(loginDates[i]);
            const gmtPlus9DateString = new Intl.DateTimeFormat('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                timeZone: 'Asia/Tokyo'
            }).format(originalDate);
            const login_date = gmtPlus9DateString.split('/')[2] + '-' + gmtPlus9DateString.split('/')[0] + '-' + gmtPlus9DateString.split('/')[1];
            loginDates[i] = login_date;
        }

        document.querySelectorAll('.calendar__entry').forEach(entry => {
            let dateElement = entry.querySelector('time');
            let date = dateElement.getAttribute('datetime');

            if (loginDates.includes(date)) {
                let imgElement = entry.querySelector('.calendar__icon img');
                imgElement.classList.add('login-user-icon');
                imgElement.src = imgElement.getAttribute('data-src');
            }
        });
    }
};

async function loadComments(cursor = null, isFirstRequest = false) {
    let article_id = document.querySelector('#comment-box').getAttribute('article-id');
    let url = `${window.AppProxyPath}/api/customers/daily/get-comments/${article_id}`;

    const deletedCommentId = sessionStorage.getItem('deletedCommentId');

    const params = new URLSearchParams();
    if (cursor) params.append('cursor', cursor);
    if (deletedCommentId) params.append('deletedCommentId', deletedCommentId);
    if (isFirstRequest) params.append('isFirstRequest', 'true');

    if (params.toString()) {
        url += `?${params.toString()}`;
    }

    const result = await fetch(url, {
        method: 'get',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const res = await result.json();
    if (res.comments) {
        if (!res.pageInfo.hasNextPage) {
            document.querySelector('#showMoreComments').remove();
        } else {
            document.querySelector('#showMoreComments').setAttribute('cursor', res.pageInfo.endCursor);
        }
        res.comments.forEach(comment_data => {
            const commentItem = createCommentItem(comment_data);
            document.querySelector('#comment-box').appendChild(commentItem);
        });
    }
    const himekuriComments = document.querySelectorAll('.mizkan__top__main__comment-item');

    let allText = '';
    himekuriComments.forEach(himekuriComment => {
        const commentName = himekuriComment.querySelector('.name').textContent;
        const commentContent = himekuriComment.querySelector('.comment-content').textContent;
        allText += ' ' + commentName + commentContent;
    });

    fontJun34(allText);

    document.querySelector('.comment-loading').classList.remove('is-loading');
}

function createCommentItem(comment_data) {
    const commentItem = document.createElement('div');
    commentItem.classList.add('mizkan__top__main__comment-item');

    const authorIcon = document.createElement('img');
    // ドメインに基づいて異なるアイコンURLを設定
    let defaultIconUrl;
    if (window.location.hostname === '365.mizkan.co.jp') {
        defaultIconUrl = '//365.mizkan.co.jp/cdn/shop/files/user_icon_1.png';
    } else {
        defaultIconUrl = '//dev-365.myshopify.com/cdn/shop/files/user_icon_1.png';
    }
    authorIcon.classList.add('author-icon');
    const authorIconUrl = comment_data.node.author.usericon || defaultIconUrl;
    authorIcon.src = authorIconUrl;
    authorIcon.alt = comment_data.node.author.nickname + "のアイコン";
    console.log(authorIcon.src)
    commentItem.appendChild(authorIcon);

    const textBox = document.createElement('div');
    textBox.classList.add('mizkan__top__main__comment__text-box');
    commentItem.appendChild(textBox);

    const name = document.createElement('span');
    name.classList.add('name');
    name.textContent = comment_data.node.author.nickname;
    textBox.appendChild(name);

    const commentContent = document.createElement('p');
    commentContent.classList.add('comment-content');
    commentContent.textContent = comment_data.node.content;
    textBox.appendChild(commentContent);

    if (comment_data.node.author.customer_id === document.querySelector('#comment-box').getAttribute('customer-id')) {
        const removeButton = document.createElement('div');
        removeButton.classList.add('daily_pad_calendar_comment_remove');
        const removeSpan = document.createElement('span');
        removeSpan.classList.add('daily_pad_calendar_comment_remove_span');
        removeSpan.textContent = '削除する';
        removeButton.appendChild(removeSpan);

        removeButton.setAttribute('data-comment-id', comment_data.node.id);
        removeButton.setAttribute('data-customer-id', comment_data.node.author.customer_id);

        textBox.appendChild(removeButton);
    }
    return commentItem;
}

$(document).ready(function () {
    $('.mizkan__news__articles__article').hide();
    $('.mizkan__news__articles__article').slice(0, 3).show();

    $('#mizkan__show__more__news').click(function (e) {
        e.preventDefault();

        var hiddenArticles = $('.mizkan__news__articles__article:hidden').slice(0, 6);
        hiddenArticles.each(function (index, hiddenArticle) {
            $(hiddenArticle).css('display', 'block');
        });

        if ($('.mizkan__news__articles__article:hidden').length === 0) {
            $('#mizkan__show__more__news').hide();
        }
    });

    if ($('.mizkan__news__articles__article').length <= 3) {
        $('#mizkan__show__more__news').hide();
    }
});

window.addEventListener('DOMContentLoaded', (event) => {
    // divの大きさを取得
    const div = document.querySelector('.mizkan__top__fixed');
    const divWidth = div.offsetWidth;
    const divHeight = div.offsetHeight;

    // imgに大きさを適用
    const img = document.querySelector('.mizkan__top__img-box__bg img');
    img.style.width = `${divWidth}px`;
    img.style.height = `${divHeight}px`;
});

document.addEventListener("DOMContentLoaded", function () {
    const commentElement = document.querySelector(".daily_pad_calendar_comment");
    const commentPlane = document.querySelector(".daily_pad_calendar_send_plane");
    const commentArea = document.querySelector("#comment-content");
    const commentWrapper = document.querySelector("#daily_pad_calendar_comment_wrapper");
    const commentForm = document.querySelector("#article-comment-form");
    if (!commentElement) return;
    commentElement.addEventListener("click", function (event) {
        if (event.currentTarget.classList.contains("logout")) {
            window.theme.openModal('#modal_login_appeal');
            return;
        }
    })
    if (!commentPlane) return;
    commentPlane.addEventListener("click", function (event) {
        event.stopPropagation();
        if (!commentArea || !commentWrapper || !commentForm || commentWrapper.value.trim() == "") return;
        const commentSubmit = commentForm.querySelector("input[type='submit']");
        if (!commentSubmit) return;
        commentArea.value = commentWrapper.value;
        checkNGWordAndSubmit();
    })

});

async function checkNGWordAndSubmit() {
    const commentContent = document.getElementById("comment-content").value;
    const commentBox = document.querySelector('#comment-box');
    const articleId = commentBox.getAttribute('article-id');
    const blogId = commentBox.getAttribute('blog-id');
    const customerId = commentBox.getAttribute('customer-id');
    const author = document.getElementById("comment-author").value;
    const email = document.getElementById("comment-email").value;

    // 絵文字を判別する正規表現
    const emojiPattern = /[\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F1E0}-\u{1F1FF}\u{1F900}-\u{1F9FF}\u{1FA70}-\u{1FAFF}\u{1F300}-\u{1F5FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FB00}-\u{1FBFF}\u{1FC00}-\u{1FCFF}\u{1FD00}-\u{1FDFF}\u{1FE00}-\u{1FEFF}\u{1FF00}-\u{1FFFF}]/gu;

    if (emojiPattern.test(commentContent)) {
        document.querySelector('.profanity-warning').removeAttribute('hidden');
        document.querySelector('.profanity-warning').textContent = '絵文字はご利用いただけません。';
        document.querySelector('.cooklist_loading_container').style.display = 'none';
        document.querySelector('.mizkan__top').hidden = false;

        const element = document.querySelector('.profanity-warning');
        const headerOffset = 150;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
        return;
    } else {
        document.querySelector('.profanity-warning').setAttribute('hidden', '');
    }

    document.querySelector('.cooklist_loading_container').style.display = 'block';
    document.querySelector('.mizkan__top').hidden = true;

    try {
        const response = await fetch(`${window.AppProxyPath}/api/customers/daily/comment?logged_in_customer_id=${customerId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                article_id: articleId,
                blog_id: blogId,
                body: commentContent,
                author: author,
                email: email
            }),
        });
        const data = await response.json();

        if (!data.success) {
            document.querySelector('.cooklist_loading_container').style.display = 'none';
            document.querySelector('.mizkan__top').hidden = false;

            switch (data.error_code) {
                case 'COMMENT_LIMIT_REACHED':
                    document.querySelector('.profanity-warning').removeAttribute('hidden');
                    document.querySelector('.profanity-warning').textContent = '投稿は1日3回までとなります。';
                    const limitElement = document.querySelector('.profanity-warning');
                    const limitHeaderOffset = 150;
                    const limitElementPosition = limitElement.getBoundingClientRect().top;
                    const limitOffsetPosition = limitElementPosition + window.scrollY - limitHeaderOffset;
                    window.scrollTo({
                        top: limitOffsetPosition,
                        behavior: "smooth"
                    });
                    return;
                case 'NG_WORD_DETECTED':
                    open_modal_ng('#modal_input_error');
                    return;
                case 'UNAUTHORIZED':
                    window.theme.openModal('#modal_login_appeal');
                    return;
                default:
                    open_modal_error('#error_modal');
                    return;
            }
        }

        localStorage.setItem('comment_point', data.get_point);
        window.location.reload();
    } catch (error) {
        console.error('Error:', error);
        document.querySelector('.cooklist_loading_container').style.display = 'none';
        document.querySelector('.mizkan__top').hidden = false;
        open_modal_error('#error_modal');
    }
}
document.addEventListener('DOMContentLoaded', function () {
    var textarea = document.getElementById('daily_pad_calendar_comment_wrapper');
    textarea.addEventListener('keydown', function (e) {
        if (e.keyCode === 13) { // 13はエンターキーのキーコード
            e.preventDefault(); // イベントのデフォルト動作（この場合は改行）を防ぐ
            return false; // 一部のブラウザでは、preventDefaultだけでは足りない場合があるため
        }
    });
});
